"use strict";

import { isEscape, returnFocus, trapFocus } from "./utils.js";

import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const projects = document.querySelectorAll('.project-details');
projects.forEach(element => {
    const swiperContainer = element.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
        modules: [Navigation, Pagination, EffectFade, A11y],
        a11y: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        speed: 1000
        // effect: 'fade',
        // fadeEffect: {
        //     crossFade: true
        // }
    });
});

function closeProject() {
    projects.forEach(el => {
        el.classList.remove('show');
    });
    document.body.classList.remove('no-scroll');
}

const projectTriggers = document.querySelectorAll('.project-details-trigger');
projectTriggers.forEach(el => {
    el.addEventListener("click", e => {
        e.preventDefault();
        const project = document.getElementById(e.target.dataset.target);
        if (project) {
            project.classList.add('show');
            trapFocus(project);
            window.returnFocusTo = e.target;
            document.body.classList.add('no-scroll');

            const close = project.querySelector('.close');
            close.addEventListener("click", e => {
                closeProject();
            });

        }
    });
});

document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        closeProject()
        returnFocus();
    }
});
